var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form", { on: { change: _vm.logChangeData } }, [
    _c("div", { staticClass: "setting_content" }, [
      _c("div", { staticClass: "setting_content_main" }, [
        _c("h2", { staticClass: "setting_content_title" }, [
          _vm._v(_vm._s(_vm.labelProperties.HEAD_TITLE))
        ]),
        _c("div", { staticClass: "setting_unit" }, [
          _c("p", { staticClass: "setting_unit_title" }, [
            _vm._v(_vm._s(_vm.labelProperties.SEARCH_SCREEN))
          ]),
          _c("div", { staticClass: "setting_unit_item" }, [
            _c("p", { staticClass: "setting_unit_label" }, [
              _vm._v(_vm._s(_vm.labelProperties.LABEL_BUTTON))
            ]),
            _c("div", { staticClass: "setting_unit_form" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.button.searchBtn,
                    expression: "button.searchBtn"
                  }
                ],
                staticClass: "setting_form_text",
                attrs: {
                  type: "text",
                  placeholder: _vm.labelProperties.PLACE_HOLDER_SEARCH_SCREEN
                },
                domProps: { value: _vm.button.searchBtn },
                on: {
                  change: _vm.validateSearchBtn,
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.button, "searchBtn", $event.target.value)
                  }
                }
              }),
              _vm.isSearchBtnError
                ? _c("p", { staticClass: "error_msg" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.maxlengthProperties.MAX_LENGTH_BUTTON) +
                        _vm._s(
                          _vm.maxlengthMessageProperties.MESSAGE_MAX_LENGTH
                        ) +
                        "\n            "
                    )
                  ])
                : _vm._e()
            ])
          ])
        ]),
        _c("div", { staticClass: "setting_unit" }, [
          _c("p", { staticClass: "setting_unit_title" }, [
            _vm._v(_vm._s(_vm.labelProperties.LIST_SCREEN))
          ]),
          _c("div", { staticClass: "setting_unit_item" }, [
            _c("p", { staticClass: "setting_unit_label" }, [
              _vm._v(_vm._s(_vm.labelProperties.LABEL_BUTTON))
            ]),
            _c("div", { staticClass: "setting_unit_form" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.button.listBtn,
                    expression: "button.listBtn"
                  }
                ],
                staticClass: "setting_form_text",
                attrs: {
                  type: "text",
                  placeholder: _vm.labelProperties.PLACE_HOLDER_LIST_SCREEN
                },
                domProps: { value: _vm.button.listBtn },
                on: {
                  change: _vm.validateListBtn,
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.button, "listBtn", $event.target.value)
                  }
                }
              }),
              _vm.isListBtnError
                ? _c("p", { staticClass: "error_msg" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.maxlengthProperties.MAX_LENGTH_BUTTON) +
                        _vm._s(
                          _vm.maxlengthMessageProperties.MESSAGE_MAX_LENGTH
                        ) +
                        "\n            "
                    )
                  ])
                : _vm._e()
            ])
          ]),
          _c("div", { staticClass: "setting_unit_item" }, [
            _c("p", { staticClass: "setting_unit_label" }, [
              _vm._v(_vm._s(_vm.advanceSettingProperties.PRINT_BUTTON))
            ]),
            _c("div", { staticClass: "setting_unit_form" }, [
              _c("label", { staticClass: "setting_form_radio_label" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.displaySettingJobList.print,
                      expression: "displaySettingJobList.print"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    value: "true",
                    id: "is_print_list_0",
                    checked: "checked"
                  },
                  domProps: {
                    checked: _vm._q(_vm.displaySettingJobList.print, "true")
                  },
                  on: {
                    change: function($event) {
                      return _vm.$set(
                        _vm.displaySettingJobList,
                        "print",
                        "true"
                      )
                    }
                  }
                }),
                _c(
                  "label",
                  {
                    staticClass: "setting_form_radio_text",
                    attrs: { for: "is_print_list_0" }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.advanceSettingProperties.DISPLAY) +
                        "\n              "
                    )
                  ]
                )
              ]),
              _c("label", { staticClass: "setting_form_radio_label" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.displaySettingJobList.print,
                      expression: "displaySettingJobList.print"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    value: "false",
                    id: "is_print_list_1"
                  },
                  domProps: {
                    checked: _vm._q(_vm.displaySettingJobList.print, "false")
                  },
                  on: {
                    change: function($event) {
                      return _vm.$set(
                        _vm.displaySettingJobList,
                        "print",
                        "false"
                      )
                    }
                  }
                }),
                _c(
                  "label",
                  {
                    staticClass: "setting_form_radio_text",
                    attrs: { for: "is_print_list_1" }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.advanceSettingProperties.NOT_DISPLAY) +
                        "\n              "
                    )
                  ]
                )
              ])
            ])
          ])
        ]),
        _c("div", { staticClass: "setting_unit" }, [
          _c("p", { staticClass: "setting_unit_title" }, [
            _vm._v(_vm._s(_vm.labelProperties.DETAIL_SCREEN))
          ]),
          _c("div", { staticClass: "setting_unit_item" }, [
            _c("p", { staticClass: "setting_unit_label" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.labelProperties.LABEL_DETAIL_BUTTON) +
                  "\n          "
              )
            ]),
            _c("div", { staticClass: "setting_unit_form" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.button.detailBtn,
                    expression: "button.detailBtn"
                  }
                ],
                staticClass: "setting_form_text",
                attrs: {
                  type: "text",
                  placeholder: _vm.labelProperties.PLACE_HOLDER_DETAIL_SCREEN
                },
                domProps: { value: _vm.button.detailBtn },
                on: {
                  change: _vm.validateDetailBtn,
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.button, "detailBtn", $event.target.value)
                  }
                }
              }),
              _vm.isDetailBtnError
                ? _c("p", { staticClass: "error_msg" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.maxlengthProperties.MAX_LENGTH_BUTTON) +
                        _vm._s(
                          _vm.maxlengthMessageProperties.MESSAGE_MAX_LENGTH
                        ) +
                        "\n            "
                    )
                  ])
                : _vm._e()
            ])
          ]),
          _c("div", { staticClass: "setting_unit_item" }, [
            _c("p", { staticClass: "setting_unit_label" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.labelProperties.LABEL_CONTACT_BUTTON) +
                  "\n          "
              )
            ]),
            _c("div", { staticClass: "setting_unit_form" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.button.contactBtn,
                    expression: "button.contactBtn"
                  }
                ],
                staticClass: "setting_form_text",
                attrs: {
                  type: "text",
                  placeholder: _vm.labelProperties.PLACE_HOLDER_CONTACT_SCREEN
                },
                domProps: { value: _vm.button.contactBtn },
                on: {
                  change: _vm.validateContactBtn,
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.button, "contactBtn", $event.target.value)
                  }
                }
              }),
              _vm.isContactBtnError
                ? _c("p", { staticClass: "error_msg" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.maxlengthProperties.MAX_LENGTH_BUTTON) +
                        _vm._s(
                          _vm.maxlengthMessageProperties.MESSAGE_MAX_LENGTH
                        ) +
                        "\n            "
                    )
                  ])
                : _vm._e()
            ])
          ]),
          _c("div", { staticClass: "setting_unit_item" }, [
            _c("p", { staticClass: "setting_unit_label" }, [
              _vm._v(_vm._s(_vm.advanceSettingProperties.PRINT_BUTTON))
            ]),
            _c("div", { staticClass: "setting_unit_form" }, [
              _c("label", { staticClass: "setting_form_radio_label" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.displaySettingJobDetail.print,
                      expression: "displaySettingJobDetail.print"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    value: "true",
                    id: "is_print_detail_0",
                    checked: "checked"
                  },
                  domProps: {
                    checked: _vm._q(_vm.displaySettingJobDetail.print, "true")
                  },
                  on: {
                    change: function($event) {
                      return _vm.$set(
                        _vm.displaySettingJobDetail,
                        "print",
                        "true"
                      )
                    }
                  }
                }),
                _c(
                  "label",
                  {
                    staticClass: "setting_form_radio_text",
                    attrs: { for: "is_print_detail_0" }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.advanceSettingProperties.DISPLAY) +
                        "\n              "
                    )
                  ]
                )
              ]),
              _c("label", { staticClass: "setting_form_radio_label" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.displaySettingJobDetail.print,
                      expression: "displaySettingJobDetail.print"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    value: "false",
                    id: "is_print_detail_1"
                  },
                  domProps: {
                    checked: _vm._q(_vm.displaySettingJobDetail.print, "false")
                  },
                  on: {
                    change: function($event) {
                      return _vm.$set(
                        _vm.displaySettingJobDetail,
                        "print",
                        "false"
                      )
                    }
                  }
                }),
                _c(
                  "label",
                  {
                    staticClass: "setting_form_radio_text",
                    attrs: { for: "is_print_detail_1" }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.advanceSettingProperties.NOT_DISPLAY) +
                        "\n              "
                    )
                  ]
                )
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }